module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-discount-rate-comparison__pie"
  }, [(_vm.title) ? _c('h3', [_vm._v("\n        " + _vm._s(_vm.title) + " (" + _vm._s(_vm.rate) + ")\n    ")]) : _c('h3', [_vm._v("\n        " + _vm._s(_vm.rate) + "\n    ")]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "chart-data": _vm.chartData,
      "options": _vm.chartOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.total !== null) ? _c('div', {
    staticClass: "u-text-center"
  }, [_c('strong', [_vm._v("\n            " + _vm._s(_vm.totalText) + "\n        ")]), _vm._v("\n        " + _vm._s(_vm.currencyFormat(_vm.total)) + "\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e985d390!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/components/charts/Pie.vue
// module id = 1830
// module chunks = 0